export type OnClick = React.MouseEvent<SVGElement, MouseEvent> | React.MouseEvent<HTMLDivElement, MouseEvent>;

export enum TypesFilterButton {
  Today,
  Tomorrow,
  Yesterday,
  Week,
  Month,
}

export enum DateRangeStepType {
  Day,
  Week,
  Month,
  Year,
}
